import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function NotFound() {
    return (
        <section data-testid="page-404" className="min-h-[60vh] bg-[#101A2C] text-white flex items-center grain-overlay">
            <div className="container-vl py-24 grid grid-cols-12 gap-8 items-center">
                <div className="col-span-12 md:col-span-7">
                    <p className="font-mono text-xs tracking-[0.3em] text-[#F4A000] mb-4">[ 404 — ROUTE NOT FOUND ]</p>
                    <h1 className="heading-h1 text-white mb-5">Looks like this shipment went off-route.</h1>
                    <p className="text-[#CBD5E1] max-w-md mb-8">The page you're looking for doesn't exist. Let's get you back on track.</p>
                    <Link to="/" data-testid="404-home" className="btn-primary">
                        <ArrowLeft className="h-4 w-4" /> Back to Home
                    </Link>
                </div>
                <div className="col-span-12 md:col-span-5">
                    <p className="font-display leading-none text-[#28406A]" style={{ fontSize: "clamp(5rem, 25vw, 16rem)" }}>404</p>
                </div>
            </div>
        </section>
    );
}
